import whyUsImage from "assets/images/why-us.svg";
import Timeline from "components/MainPage/Timeline";
import { useTranslation } from "react-i18next";

function WhyUs() {

	const { t } = useTranslation();

	return (
		<div className="container">
			<div className="bg-gradient-to-br from-blue-900 via-blue-700 to-sky-400 rounded-3xl shadow flex gap-8 text-white p-7 sm:p-10 md:p-20 mt-10 xs:mt-14 sm:mt-24 md:mt-32">
				<div className="flex flex-col w-full lg:w-3/5">
					<div className="mb-5 md:mb-10 text-2xl sm:text-3xl md:text-5xl font-medium">
						{ t(`mainPage.whyUs.title`) }
					</div>
					<p className="text-sm md:text-lg font-normal">
						{ t(`mainPage.whyUs.description`) }
					</p>
					<Timeline/>
				</div>
				<img src={ whyUsImage } alt="why-us-image" className="w-2/5 hidden lg:block"/>
			</div>
		</div>
	);
}

export default WhyUs;